import {Pipe, PipeTransform} from "@angular/core";
import {ScenarioRecordingState} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

@Pipe({
	name: "getScenarioRecordingStateStringForCustomer",
	pure: false,
	standalone: true,
})
export class GetScenarioRecordingStateStringForCustomerPipe implements PipeTransform {
	T = Translations;

	constructor(private _translate: TranslateService) {}

	transform(value: ScenarioRecordingState): string {
		switch (value) {
			case ScenarioRecordingState.Aborted:
				return this._translate.instant(this.T.SHARED_SCENARIO_RECORDING_STATE_ABORTED);
			case ScenarioRecordingState.Prepared:
				return this._translate.instant(this.T.SHARED_SCENARIO_RECORDING_STATE_PREPARED);
			case ScenarioRecordingState.Recording:
				return this._translate.instant(this.T.SHARED_SCENARIO_RECORDING_STATE_RECORDING);
			case ScenarioRecordingState.Stopped:
				return this._translate.instant(this.T.SHARED_SCENARIO_RECORDING_STATE_STOPPED);
		}
	}
}
